import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FeedbackService} from '../_services/feedback.service';
import {take} from 'rxjs';
import {SnackbarService} from '../_services/snackbar.service';
import {Community} from "../_types/communities";
import {LocalStorageService} from "../_services/local-storage.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ContentService} from "../_services/content.service";

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrl: './contact.component.scss'
})
export class ContactComponent {
    loading: boolean = false;
    contactForm: FormGroup;
    community: Community | null = null
    timer: number = 0;

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly feedbackService: FeedbackService,
        private readonly contentService: ContentService,
        private readonly snackbarService: SnackbarService,
        private readonly localStorageService: LocalStorageService
    ) {
        this.contactForm = this.formBuilder.group({
            message: ['', Validators.required],
            isAnonymous: [false],
        });
        this.contentService.getCurrentDashboardCommunity()
            .pipe(takeUntilDestroyed())
            .subscribe(community => {
                this.community = community;
            });
    }

    submit(): void {
        this.loading = true;
        this.feedbackService.sendMessage(this.contactForm.get('message')?.value, this.contactForm.get('isAnonymous')?.value, this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null)?.id)
            .pipe(take(1))
            .subscribe({
                next: (): void => {
                    this.loading = false;
                    this.snackbarService.openSuccessSnackBar('Message sent successfully');
                    this.contactForm.get('message')?.reset('');
                    this.timer = 30;
                    let timeleft: number = 30;
                    let that: this = this;
                    const downloadTimer = setInterval(function (): void {
                        if (timeleft <= 0) {
                            clearInterval(downloadTimer);
                        }
                        that.timer = timeleft;
                        timeleft -= 1;
                    }, 1000);
                },
                error: (err): void => {
                    this.loading = false;
                    this.snackbarService.openErrorSnackBar(err?.details ?? err);
                }
            })
    }
}
